import React from 'react';
const SNAKKER_LOGO = 'https://cdn.magicpatterns.com/uploads/98Gnmk6tUobFbbxiaTEqD8/image.png';
export function PresentationLogo() {
  return <div className="pointer-events-none absolute right-4 top-4 z-[45] rounded-lg bg-white/90 px-2 py-1 shadow-sm ring-1 ring-black/5" data-id="element-198" data-mp="3v54u2dh2igds">
      <img src={SNAKKER_LOGO} alt="Snakker" className="h-7 w-auto object-contain" data-id="element-199" data-mp="3mdcpukin03hn" />
    </div>;
}